import { css } from 'styled-components';
export const getComboBoxFocusBorderStyles = ({ showFullFocusBorder, isDropdownReverse, }) => {
    const sideBorders = css `
    border-left: 2px solid ${({ theme }) => theme.colors.AccentPurple};
    border-right: 2px solid ${({ theme }) => theme.colors.AccentPurple};
  `;
    if (!showFullFocusBorder) {
        return css `
      input {
        ${sideBorders}
      }
    `;
    }
    return css `
    input {
      ${sideBorders}
      ${isDropdownReverse
        ? css `
            border-bottom: 2px solid ${({ theme }) => theme.colors.AccentPurple};
            border-radius: 0 0 8px 8px;
            border-top: none;
          `
        : css `
            border-top: 2px solid ${({ theme }) => theme.colors.AccentPurple};
            border-radius: 8px 8px 0 0;
          `}
    }
  `;
};
//# sourceMappingURL=BKJComboBox.styles.js.map